import { decideBranch } from '../flow-branches/decideBranch';
import { clearNextSteps, finishSignup, goNextStep } from '../store/flow/action-creators';
import { getIsAccountCreationStep } from './getIsAccountCreationStep';
import { skipPrefilled } from './skipPrefilled';
export const setNextStep = ({
  rebuilder,
  accountCreated = false
} = {}) => (dispatch, getState) => {
  const state = getState();
  const transformedFlow = decideBranch(state, dispatch);
  let flowSteps = skipPrefilled(transformedFlow, state);
  flowSteps = rebuilder ? rebuilder(flowSteps) : flowSteps;

  if (!flowSteps) {
    return null;
  }

  const isAccountCreationStep = getIsAccountCreationStep(getState(), flowSteps);

  if (isAccountCreationStep && !accountCreated) {
    if (flowSteps.length === 0) {
      dispatch(clearNextSteps());
    }

    return dispatch(finishSignup());
  } else {
    return dispatch(goNextStep({
      step: flowSteps[0],
      nextSteps: flowSteps.slice(1)
    }));
  }
};